import { getI18n } from '@/helpers/i18n';
import UserAccountIndex from '@/views/UserAccountRoot.vue';
import UserAccountSettings from '@/views/UserAccountSettings.vue';
import UserAccountNotifications from '@/views/UserAccountNotifications.vue';
import UserAccountSettingsProfile from '@/views/UserAccountSettingsProfile.vue';

export default [
    {
        path: '/useraccount',
        name: 'useraccount',
        component: UserAccountIndex,
        meta: {
            requiresAuth: true,
            title: () => getI18n().t('mein_bereich'),
            breadcrumbTitle: () => getI18n().t('mein_bereich'),
            breadcrumbTo: { name: 'useraccount-settings' }
        },
        children: [
            {
                path: '',
                name: 'useraccount-settings',
                component: UserAccountSettings,
                requiresAuth: true,
                meta: {
                    requiresAuth: true,
                    title: () => getI18n().t('settings'),
                    skipBreadcrumb: true
                },
                children: [{
                        path: '',
                        name: 'useraccount-settings-profile',
                        component: UserAccountSettingsProfile,
                        meta: {
                            requiresAuth: true,
                            title: () => getI18n().t('profile'),
                            breadcrumbTitle: () => getI18n().t('profile'),
                            skipBreadcrumb: true
                        }
                    }]
            },
            {
                path: 'messages',
                name: 'useraccount-notifications',
                component: UserAccountNotifications,
                meta: {
                    requiresAuth: true,
                    title: () => getI18n().t('notifications'),
                }
            }
        ]
    }
];
